export const mds = {
    test: 'https://d13ferbq0fph5q.cloudfront.net',
    acceptance: 'https://dpsckowr07x5d.cloudfront.net',
    prod: 'https://d7y93rgfq52sd.cloudfront.net',
};
